import { render, staticRenderFns } from "./FakultasTable.vue?vue&type=template&id=006b1f8b&"
import script from "./FakultasTable.vue?vue&type=script&lang=js&"
export * from "./FakultasTable.vue?vue&type=script&lang=js&"
import style0 from "./FakultasTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports